import { BootOverlay } from './boot/BootOverlay.jsx';
import { AuthView } from './auth/AuthView.jsx';
import { LegalView } from './legal/LegalView.jsx';
import { AppShell } from './shell/AppShell.jsx';
import { QuickActions } from './quick/QuickActions.jsx';
import { DialogHost } from './feedback/DialogHost.jsx';

/**
 * Stable application shell. Feature controllers may target the preserved ids/data-* hooks,
 * while structure and lifecycle are owned by Preact.
 */
export function AppScaffold() {
  return (
    <>
      <BootOverlay />
      <AuthView />
      <LegalView />
      <AppShell />
      <QuickActions />
      <DialogHost />
    </>
  );
}
